export default __webpack_public_path__ + "static/iso-4140d903a9e7adba98136dc6d70c27bd.png";